/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

class ResourceLockPlugin {
    constructor(strapiBaseUrl) {
        this.strapiBaseUrl = strapiBaseUrl;
    }
    onRegister(app) {
        this.app = app;
    }
    getName() {
        return "ResourceLockPlugin";
    }
    lock(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.strapiBaseUrl}/locked-resources/lock/${resource}`, {
                method: "POST",
                headers: { "content-type": "application/json" },
                credentials: "include",
            });
            if (!response.ok) {
                throw new Error("Failed to lock resource");
            }
        });
    }
    unlock(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch(`${this.strapiBaseUrl}/locked-resources/unlock/${resource}`, {
                    method: "DELETE",
                    credentials: "include",
                });
                if (!response.ok) {
                    throw new Error("Failed to unlock resource");
                }
            }
            catch (error) {
                console.error("Error unlocking resource:", error);
            }
        });
    }
    isLocked(resource) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.strapiBaseUrl}/locked-resources/is-locked/${resource}`, {
                credentials: "include",
            });
            if (!response.ok) {
                throw new Error("Failed to fetch lock status");
            }
            const data = (yield response.json());
            return { isLocked: data.isLocked, lockedBy: data.lockedBy };
        });
    }
    getLockedItems(resources) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.strapiBaseUrl}/locked-resources/is-locked`, {
                method: "POST",
                headers: { "content-type": "application/json" },
                credentials: "include",
                body: JSON.stringify(resources),
            });
            if (!response.ok) {
                throw new Error("Failed to fetch lock status for multiple resources");
            }
            const data = (yield response.json());
            return data;
        });
    }
    getLockedProjects(projectIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.strapiBaseUrl}/locked-resources/is-locked/projects`, {
                method: "POST",
                headers: { "content-type": "application/json" },
                credentials: "include",
                body: JSON.stringify(projectIds),
            });
            if (!response.ok) {
                throw new Error("Failed to fetch lock status for projects");
            }
            const data = (yield response.json());
            return data;
        });
    }
}

export { ResourceLockPlugin };
